import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import config from '../../../config';
import { Card, Row, Col, Form, Input, Table, Button, Space, message, Popconfirm } from 'antd';
import ValidatorHelpers from '../../helpers/ValidatorHelper';
import EditSlide from './EditSlide';
import { usePersistedStore } from '../../../store/persisted-store';

const SlidesManagement = () => {
    const { auth, business } = usePersistedStore();
    const navigate = useNavigate();
    const [mainForm] = Form.useForm();
    const businessToken = business.currentBusiness.token;
    const userToken = auth.userToken;
    const [editModal, setEditModal] = useState(false);
    const [selectedSlide, setSelectedSlide] = useState([]);
    const [data, setData] = useState([]);

    useEffect(() => {
        if (!businessToken)
            navigate('/dashboard');
        getSlides()
    }, [navigate, businessToken])

    const getSlides = () => {
        axios({
            method: "GET",
            baseURL: config.apiUrls(),
            url: "/v1/business/Slider",
            headers: { "token": businessToken, Authorization: `Bearer ${userToken}` }
        }).then((response) => {
            setData(response.data)
        }).catch((error) => {
            message.error(error.Message)
        })
    }

    const deleteSlides = (id) => {
        axios({
            method: "delete",
            baseURL: config.apiUrls(),
            url: `/v1/business/Slider/${id}`,
            headers: { "token": businessToken, Authorization: `Bearer ${userToken}` }
        }).then((response) => {
            message.success(response.data);
            getSlides();
        }).catch((error) => {
            message.error(error.Message)
        })
    }

    const columns = [
        {
            title: "عنوان",
            dataIndex: "Title",
            key: "Title",
            render: (text, _) => <span>{text}</span>

        },
        {
            title: "نام فایل",
            dataIndex: "FileName",
            key: "FileName",
            render: (text, _) => <span>{text}</span>

        },
        {
            title: "فایل دسکتاپ",
            dataIndex: "DesktopAddress",
            key: "DesktopAddress",
            render: (text, _) => text && <img alt="" src={text} width="100px" height="20px" />

        },
        {
            title: "فایل تبلت",
            dataIndex: "TabletAddress",
            key: "TabletAddress",
            render: (text, _) => text && <img alt="" src={text} width="100px" height="20px" />

        },
        {
            title: "فایل موبایل",
            dataIndex: "MobileAddress",
            key: "MobileAddress",
            render: (text, _) => text && <img alt="" src={text} width="100px" height="20px" />

        },
        {
            title: "وضعیت دسکتاپ",
            dataIndex: "EnableDesktop",
            key: "EnableDesktop",
            render: (text, _) => text ? 'فعال' : 'غیرفعال'

        },
        {
            title: "وضعیت تبلت",
            dataIndex: "EnableTablet",
            key: "EnableTablet",
            render: (text, _) => text ? 'فعال' : 'غیرفعال'

        },
        {
            title: "وضعیت موبایل",
            dataIndex: "EnableMobile",
            key: "EnableMobile",
            render: (text, _) => text ? 'فعال' : 'غیرفعال'

        },
        {
            title: "ترتیب",
            dataIndex: "Order",
            key: "Order",
            render: (text, _) => <span>{text}</span>

        },
        {
            title: "لینک",
            dataIndex: "Link",
            key: "Link",
            render: (text, _) => <span>{text}</span>
        },
        {
            title: "",
            dataIndex: "operation",
            key: "operation",
            render: (_, record) => <Space size="middle">
                <button type="dashed" className="btn btn-warning btn-sm waves-effect waves-light"
                    onClick={() => { setEditModal(true); setSelectedSlide(record) }}>
                    <i className="far fa-edit font-size-16 align-middle mr-2"></i> جزئیات
                </button>
                <Popconfirm
                    title="آیا از حذف مطمئن هستید؟"
                    onConfirm={() => deleteSlides(record.Id)}
                >
                    <button type="danger" className="btn btn-danger btn-sm waves-effect waves-light">
                        <i className="fas fa-minus font-size-16 align-middle mr-2"></i> حذف
                    </button>
                </Popconfirm>
            </Space>
        }
    ]

    const onFinish = (values) => {
        axios({
            method: "post",
            baseURL: config.apiUrls(),
            url: `/v1/business/Slider`,
            headers: { Authorization: `Bearer ${userToken}`, "token": businessToken },
            data: values
        }).then((res) => {
            message.success(res);
            getSlides();
        }).catch((error) => {
            message.error(error.Message)
        })
    }

    const onFinishFailed = (errorInfo) => {
        mainForm.scrollToField(errorInfo.errorFields[0].name, {
            scroll: {
                offsetTop: 65,
            }
        });
    }

    return (
        <Card>
            <Form form={mainForm} onFinish={onFinish} onFinishFailed={onFinishFailed} colon="false">
                <Row justify="space-between" gutter={16}>
                    <Col span={6}>
                        <Form.Item
                            name="Title"
                            rules={ValidatorHelpers.required("عنوان")}
                            label="عنوان">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item
                            name="FileName"
                            rules={ValidatorHelpers.required("نام فایل")}
                            label="نام فایل">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="Link"
                            label="لینک">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={3}>
                        <Form.Item
                            name="Order"
                            rules={ValidatorHelpers.required("ترتیب")}
                            label="ترتیب">
                            <Input type="tel" />
                        </Form.Item>
                    </Col>
                    <Col span={3}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit"> افزودن </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            <Table
                className="custom-table"
                bordered
                columns={columns}
                rowKey="Id"
                scroll={true}
                dataSource={data}
            />
            {editModal && <EditSlide selectedSlide={selectedSlide} editModal={editModal} closeModal={() => { setEditModal(false); getSlides() }} />}
        </Card >
    )
}

export default SlidesManagement